var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        attrs: {
          id: _vm.id,
          fields: _vm.localFields,
          items: _vm.items,
          responsive: "",
          small: "",
          filter: _vm.filter,
          "filter-included-fields": _vm.filterIncludedFields,
          "filter-function": _vm.filterFn,
          "empty-filtered-text": _vm.emptyFilteredText,
          stacked: _vm.stacked,
          busy: _vm.loading,
          "show-empty": "",
          "empty-text": _vm.emptyText,
          "per-page": _vm.itemsPerPage,
          "current-page": _vm.currentPage
        },
        on: { filtered: _vm.filtered },
        scopedSlots: _vm._u(
          [
            {
              key: "table-busy",
              fn: function() {
                return [_c("loading-anim", { attrs: { active: _vm.loading } })]
              },
              proxy: true
            },
            _vm._l(_vm.$scopedSlots, function(_, slotName) {
              return {
                key: slotName,
                fn: function(scope) {
                  return [
                    _vm.showTableCell(slotName)
                      ? _vm._t(slotName, null, null, scope)
                      : _vm._e()
                  ]
                }
              }
            })
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _vm.items.length !== 0
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-pagination", {
                    attrs: {
                      pills: "",
                      "total-rows": _vm.rows,
                      "per-page": _vm.itemsPerPage,
                      "aria-controls": _vm.id,
                      "hide-ellipsis": "",
                      "first-number": "",
                      "last-number": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "prev-text",
                          fn: function() {
                            return [
                              _c("base-icon", {
                                staticClass: "pagination-arrow",
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                  svgClasses: "reverse",
                                  color: _vm.arrowColor
                                }
                              })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "next-text",
                          fn: function() {
                            return [
                              _c("base-icon", {
                                staticClass: "pagination-arrow",
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                  color: _vm.arrowColor
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      4086823315
                    ),
                    model: {
                      value: _vm.currentPage,
                      callback: function($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.showCaption
                ? _c("b-col", [
                    _c("span", { staticClass: "float-right text-info" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "table.pagination.label",
                            _vm.paginationLabelData
                          )
                        )
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29eed2bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29eed2bf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/PaginatedTable.vue
// module id = 1567
// module chunks = 120